<template>
    <div class="bg re_sizing">
        <div class="title re_font_18">
            <van-icon @click="goBack(1)" class="icon" name="arrow-left" size="22" />
            <div>青春泡泡协议</div>
        </div>
        <div class="blank"></div>
        <div class="content">
            <div>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">一、青春泡泡：</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt;  text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">青春泡泡是专门为在校大学生开启的版块，为大学生提供社交平台，快速结识校，让陌生社交零距离。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">二、适用对象：</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">完成实名和大学生认证，且年龄在17-22岁之间的用户</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">三、使用规则：</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">1. 需要完成实名和大学生双重认证，确保平台社交安全。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">2. 平台默认赠送100次发布泡泡的机会，超出次数将按照0.05元/条收取。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">3. 每位用户都可以发布青春泡泡，上传音频、视频、照片、个人介绍、开启泡泡条</span><span
                        style="font-family:'宋体'">件</span><span style="font-family:'宋体'">。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">4. 泡泡被他人开启后，会收到预设的礼物打赏，最终会转换为可提现的金额，进入“我的-服务-待提现”中操作。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">四、注意事项</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">1.
                        您在发布泡泡信息的过程中须遵守法律、法规、规章、政策和公序良俗，内容健康，且不侵犯他人合法权益，不违反平台的任何协议或者规则。平台将对您发布的信息进行审核，若包含以下内容将无法通过平台审核或被平台删除:违反国家法律法规禁止性规定的信息;涉及政治、封建迷信、淫秽色情、赌博、暴力、恐怖、教唆犯罪的信息;侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的信息;推广微信群、
                        QQ 群等社交软件群的信息、广告信息、虚假或有误导性的信息;活动活动本身存在明显的危险性;以及其他违背社会公共利益或公共道德或依据平台规则不适合在平台上发布的信息。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">2.
                        请您注意，本活动功能仅为用户社交提供平台技术支持，活动内容均由发起者自行发布并与参与者协商确定，用户之间因活动</span><span
                        style="font-family:'宋体'">变动</span><span
                        style="font-family:'宋体'">、撤销活动或线下活动引起的纠纷须由用户自行解决并承担相应后果。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">3.
                        用户直接或通过各类方式（如站外API引用、下载等）间接使用青春泡泡服务和数据的行为，都将被视作已无条件接受本声明所涉全部内容；若用户对本声明的任何条款有异议，请停止使用</span><span
                        style="font-family:'宋体'">青春泡泡及相应</span><span style="font-family:'宋体'">小程序所提供的全部服务。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">4.
                        用户以各种方式使用青春泡泡服务和数据（包括但不限于发表、宣传介绍、转载、浏览、下载及利用青春泡泡用户发布内容）的过程中，不得以任何方式利用青春泡泡直接或间接从事违反中国法律（包括但不限于入侵非授权的计算机系统，查阅、下载、盗版、篡改任何非授权数据，传播恶意软件）、以及社会公德的行为，</span><span
                        style="font-family:'宋体'">我们</span><span
                        style="font-family:'宋体'">不为任何个人或组织的违法行为负责，亦不承担任何法律责任。必要时，我们将为公安机关提供协助。</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">用户应当恪守下述承诺： 　</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">(1)</span><span style="font-family:'宋体'">&nbsp;</span><span
                        style="font-family:'宋体'">发布、转载或提供的内容符合中国法律、社会公德；</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">(2)</span><span style="font-family:'宋体'">&nbsp;</span><span
                        style="font-family:'宋体'">不得干扰、损害和侵</span><span style="font-family:'宋体'">青春泡泡</span><span
                        style="font-family:'宋体'">的各种合法权利与利益；</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">(3)</span><span style="font-family:'宋体'">&nbsp;</span><span
                        style="font-family:'宋体'">遵守</span><span style="font-family:'宋体'">青春泡泡</span><span
                        style="font-family:'宋体'">以及与之相关的网络服务的协议、指导原则、管理细则等；</span></p>
                <p
                    style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; font-size:14pt">
                    <span style="font-family:'宋体'">(4)</span><span style="font-family:'宋体'">&nbsp;</span><span
                        style="font-family:'宋体'">我们</span><span style="font-family:'宋体'">有权对违反上述承诺的内容予以删除。</span></p>
                <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
                    <span style="font-family:Calibri">&nbsp;</span></p>
            </div>
        </div>
    </div>
</template>

<script setup>
// import { getDrawConfig } from './api.js'
import { ref, onMounted } from 'vue';
const ruleInfo = ref('{withdrawalRules}');
const goBack = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        try {
            appJsImp.finish()
        } catch (error) {
            android.finish()
        }
    }
    if (isiOS) {
        window.webkit.messageHandlers.AppModel.postMessage('finish')
    }
}

</script>

<style lang="less" scoped>
@import url(./rule.less);
</style>